<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='薪资导入'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='450'
      >
        <template v-slot:content>
           <v-card class="px-5" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-select-search
                    hide-details
                    outlined
                    label="年份选择"
                    :data='yearItems'
                    item-text="label"
                    item-value="value"
                    v-model='form.year'>
                  </v-select-search>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-select-search
                    hide-details
                    outlined
                    label="月份选择"
                    :data='monthItems'
                    item-text="label"
                    item-value="value"
                    v-model='form.month'>
                  </v-select-search>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                 <v-file-input
                    prepend-icon=''
                    accept=".xlsx,.xls"
                    label="文件选择"
                    filled rounded  dense
                    :rules="required"
                    @change='fileChange'
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions>
              <a :href="downloadUrl" download="薪资导入模版.xlsx" style="text-decoration: underline">下载模板</a>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>

          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { selectData, selectMonthData } from '@/utils/tool.js'
  import { imports } from '@/api/office/salary.js'
  import VSelectSearch from '@/components/select/v-select-search.vue'

  export default {
    name: 'SalaryUpload',
    components: {
      VSelectSearch
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        monthItems: selectMonthData(),
        yearItems: selectData(3),
        required: [
          value => !!value || '此项为必填项!'
        ],
        downloadUrl: `${process.env.BASE_URL}template/salary_info.xlsx`,
        form: {
          file: '',
          year: Number(this.$moment().format('YYYY')),
          month: Number(this.$moment().format('MM'))
        }
      }
    },
    methods: {
      fileChange (file) {
        const this_ = this
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function () {
          this_.form.file = reader.result
        }
      },
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          imports(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (!val) {
          // this.$refs.form.reset()
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
